import _ from 'lodash'

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

const toBase64WithFile = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () =>
      resolve({
        base64: reader.result,
        file,
      })
    reader.onerror = (error) => reject(error)
  })

const convertCellNested = (obj, propertyKey) => {
  const idArr = _.split(propertyKey, '.')
  const res = _.reduce(idArr, (res, id) => res[id] || {}, obj)
  return res
}

const customSortCompare = (cell) => ({
  compare: (a, b) => {
    const dataA = convertCellNested(a, cell) || ''
    const dataB = convertCellNested(b, cell) || ''
    if (dataA > dataB) return 1
    if (dataB > dataA) return -1
    return 0
  },
})

const reAlpha = /[^a-zA-Z]/g
const reNumeric = /[^0-9]/g
const customSortCompareSeat = {
  compare: (a, b) => {
    const dataA = a.seat_name || ''
    const dataB = b.seat_name || ''

    const aAlpha = dataA.replace(reAlpha, '')
    const bAlpha = dataB.replace(reAlpha, '')
    if (aAlpha === bAlpha) {
      const aNumeric = parseInt(dataA.replace(reNumeric, ''), 10)
      const bNumeric = parseInt(dataB.replace(reNumeric, ''), 10)
      return aNumeric === bNumeric ? 0 : aNumeric > bNumeric ? 1 : -1
    } else {
      return aAlpha > bAlpha ? 1 : -1
    }
  },
}

const arrayMove = (arr, oldIndex, newIndex) => {
  if (newIndex >= arr.length) return arr
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
  return arr
}

const fillEditorStyle = (e) => {
  if (!e) return ''
  const style = `
    <style>
      :root {
        --ck-color-image-caption-background: hsl(0, 0%, 97%);
        --ck-color-image-caption-text: hsl(0, 0%, 20%);
        --ck-color-table-caption-background: hsl(0, 0%, 97%);
        --ck-color-table-caption-text: hsl(0, 0%, 20%);
        --ck-image-style-spacing: 1.5em;
        --ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);
      }
      .ck-content .image > figcaption {
          display: table-caption;
          caption-side: bottom;
          word-break: break-word;
          color: var(--ck-color-image-caption-text);
          background-color: var(--ck-color-image-caption-background);
          padding: .6em;
          font-size: .75em;
          outline-offset: -1px;
      }
      .ck-content .image.image_resized {
          max-width: 100%;
          display: block;
          box-sizing: border-box;
      }
      .ck-content .image.image_resized img {
          width: 100%;
      }
      .ck-content .image.image_resized > figcaption {
          display: block;
      }
      .ck-content .image-style-block-align-left,
      .ck-content .image-style-block-align-right {
          max-width: calc(100% - var(--ck-image-style-spacing));
      }
      .ck-content .image-style-align-left,
      .ck-content .image-style-align-right {
          clear: none;
      }
      .ck-content .image-style-side {
          float: right;
          margin-left: var(--ck-image-style-spacing);
          max-width: 50%;
      }
      .ck-content .image-style-align-left {
          float: left;
          margin-right: var(--ck-image-style-spacing);
      }
      .ck-content .image-style-align-center {
          margin-left: auto;
          margin-right: auto;
      }
      .ck-content .image-style-align-right {
          float: right;
          margin-left: var(--ck-image-style-spacing);
      }
      .ck-content .image-style-block-align-right {
          margin-right: 0;
          margin-left: auto;
      }
      .ck-content .image-style-block-align-left {
          margin-left: 0;
          margin-right: auto;
      }
      .ck-content p + .image-style-align-left,
      .ck-content p + .image-style-align-right,
      .ck-content p + .image-style-side {
          margin-top: 0;
      }
      .ck-content .image-inline.image-style-align-left,
      .ck-content .image-inline.image-style-align-right {
          margin-top: var(--ck-inline-image-style-spacing);
          margin-bottom: var(--ck-inline-image-style-spacing);
      }
      .ck-content .image-inline.image-style-align-left {
          margin-right: var(--ck-inline-image-style-spacing);
      }
      .ck-content .image-inline.image-style-align-right {
          margin-left: var(--ck-inline-image-style-spacing);
      }
      .ck-content .text-tiny {
          font-size: .7em;
      }
      .ck-content .text-small {
          font-size: .85em;
      }
      .ck-content .text-big {
          font-size: 1.4em;
      }
      .ck-content .text-huge {
          font-size: 1.8em;
      }
      .ck-content .image {
          display: table;
          clear: both;
          text-align: center;
          margin: 0.9em auto;
          min-width: 50px;
      }
      .ck-content .image img {
          display: block;
          margin: 0 auto;
          max-width: 100%;
          min-width: 100%;
      }
      .ck-content .image-inline {
          display: inline-flex;
          max-width: 100%;
          align-items: flex-start;
      }
      .ck-content .image-inline picture {
          display: flex;
      }
      .ck-content .image-inline picture,
      .ck-content .image-inline img {
          flex-grow: 1;
          flex-shrink: 1;
          max-width: 100%;
      }
      .ck-content .media {
          clear: both;
          margin: 0.9em 0;
          display: block;
          min-width: 15em;
      }
      .ck-content .table > figcaption {
          display: table-caption;
          caption-side: top;
          word-break: break-word;
          text-align: center;
          color: var(--ck-color-table-caption-text);
          background-color: var(--ck-color-table-caption-background);
          padding: .6em;
          font-size: .75em;
          outline-offset: -1px;
      }
      .ck-content .table .ck-table-resized {
          table-layout: fixed;
      }
      .ck-content .table table {
          overflow: hidden;
      }
      .ck-content .table td,
      .ck-content .table th {
          position: relative;
      }
      .ck-content .table {
          margin: 0.9em auto;
          display: table;
      }
      .ck-content .table table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          height: 100%;
          border: 1px double hsl(0, 0%, 70%);
      }
      .ck-content .table table td,
      .ck-content .table table th {
          min-width: 2em;
          padding: .4em;
          border: 1px solid hsl(0, 0%, 75%);
      }
      .ck-content .table table th {
          font-weight: bold;
          background: hsla(0, 0%, 0%, 5%);
      }
      .ck-content[dir="rtl"] .table th {
          text-align: right;
      }
      .ck-content[dir="ltr"] .table th {
          text-align: left;
      }
    </style>
    `
  return `<html><head>${style}</head><body><div id="body"><div class="ck-content">${e}</div></div></body></html>`
}

const removeEditorStyle = (e) => {
  if (!e) return ''
  const index = e.indexOf('<div class="ck-content">')
  let res = ''
  if (~index) {
    const prefix = e.substring(0, index)
    const suffix = e.substring(e.length - 26, e.length)
    if (prefix && suffix === '</div></div></body></html>')
      res = e.slice(0, -26).replace(prefix, '').replace('<div class="ck-content">', '')
  }
  return res
}

const getRandomColor = () => {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

export {
  toBase64,
  toBase64WithFile,
  customSortCompare,
  customSortCompareSeat,
  arrayMove,
  fillEditorStyle,
  removeEditorStyle,
  getRandomColor,
}
